export enum StatutPeriodeEvaluation {
  PLANIFIEE = 'PLANIFIEE',
  OUVERTE = 'OUVERTE',
  FERMEE = 'FERMEE',
}

export enum StatutArchivageBulletins {
  EN_ATTENTE = 'EN_ATTENTE',
  EN_COURS = 'EN_COURS',
  PARTIEL = 'PARTIEL',
  ARCHIVE = 'ARCHIVE',
}

export interface IPeriodeEvaluation {
  id?: string;
  nom?: string;
  dateDebut?: string | null;
  dateFin?: string | null;
  ordre?: number | null;
  ecoleId?: string;
  anneeScolaireId?: string;
  cycleId?: string;
  statut?: StatutPeriodeEvaluation;
  statutArchivageBulletins?: StatutArchivageBulletins | null;
  prochaineTentativeArchivageBulletins?: string | null;
  erreurArchivageBulletins?: string | null;
}

export const defaultValue: Readonly<IPeriodeEvaluation> = {
  id: null,
  nom: '',
  dateDebut: null,
  dateFin: null,
  ordre: null,
  ecoleId: null,
  anneeScolaireId: null,
  cycleId: null,
  statut: StatutPeriodeEvaluation.PLANIFIEE,
};
